import actions from './actions'
import initialState from './state'

export default {
	namespaced: true,
	state: { ...initialState },
	mutations: {},
	getters: {},
	actions,
}
